
import Vue from 'vue';
import { saveAs } from "file-saver";
import {
  jigsV1Url,
  getSmallQRCodeUrl,
  getLargeQRCodeUrl,
} from "@/store/modules/Constants";
import AuthImage from "@/components/image/AuthImage.vue";

export default Vue.extend({
  name: 'QRCodeModal',
  components: {
    "auth-image": AuthImage,
  },
  props: {
    jigId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      qrCodeBase64: '',
      id: this.jigId,
      isDownloading: false,
    };
  },
  watch: {
    jigId(val) {
      (this as any).id = val;
    },
  },
  methods: {
    ShowPrompt() {
      (this as any).dialogVisible = true;
    },
    qrCodeSrcUrl(downloadLarge = false) {
      return `${jigsV1Url}/${this.jigId}${
        downloadLarge ? getLargeQRCodeUrl : getSmallQRCodeUrl
      }`;
    },
    async downloadQRCode() {
      this.isDownloading = true;

      const downloadURL = await (this as any).$refs[
        `authImg${(this as any).id}`
      ].getSecureDownloadLink(this.qrCodeSrcUrl(true));

      await this.triggerDownload(downloadURL);

      this.$emit('on-qr-modal-downloaded');
    },
    async triggerDownload(qrCodeBlob: any) {
      await saveAs(qrCodeBlob, `qr-code-printable-${(this as any).jigId}_8495×8495.png`);
      this.isDownloading = false;
    },
    closeModal() {
      this.$emit('on-qr-modal-close');
      (this as any).dialogVisible = false;
    },
  },
});
